<template>
  <div
    class="content-body rounded-2 white d-flex justify-content-start align-items-center nowrap w-100"
    :class="subscription_status ? 'pointer' : 'locked'"
  >
    <div
      class="section-one d-flex justify-contemt-start align-items-center nowrap nowrap"
    >
      <div class="left">
        <div class="avatar avatar-square border_grey_light_bg">
          <img v-lazy="localImg(fileType(extension))" alt class="avatar-img" />
        </div>
      </div>
      <div class="right">
        <div class="title-text brand_navy font-weight-bold">
          {{ title }}
        </div>
        <div class="subject-text color_grey_dark">
          {{ date }}
        </div>
      </div>
    </div>

    <div class="section-two">{{ teacher_name }}</div>
    <!-- Gradely -->
    <div class="section-three">
      <template v-if="subscription_status">
        <div
          @click="openDocumentViewer"
          class="btn-link link-no-underline font-weight-bold"
        >
          View
        </div>
      </template>

      <template v-else>
        <router-link to @click.prevent class="brand_tonic locked">
          <span class="icon-lock-fill font-12 mr-1"></span> Locked</router-link
        >
      </template>
    </div>

    <LibraryViewer
      v-if="getValue"
      file_type="document"
      :file_data="getDocumentData"
      @closeTriggered="show_viewer = false"
    ></LibraryViewer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { formatDate, formatTime } from "@/scripts/utilities";

export default {
  name: "WeeklyLessonNotesRow",

  components: {
    LibraryViewer: () =>
      import(
        /* webpackChunkName: "LibraryViewer" */ "@/views/globalViews/LibraryViewer"
      ),
  },

  props: {
    id: Number,
    title: String,
    extension: String,
    date: {
      type: String,
      default: "Tues Aug, 12. 2020",
    },
    teacher_name: String,
    file: Object,
  },

  computed: {
    getValue() {
      return this.show_viewer;
    },
  },

  data() {
    return {
      show_viewer: false,
      getDocumentData: {},
      subscription_status: false,
    };
  },

  mounted() {
    this.callPaymentStatus();
  },

  methods: {
    ...mapActions(["getSubscriptionPaymentStatus"]),

    toggleViewer() {
      this.show_viewer = !this.show_viewer;
      console.log(this.show_viewer);
    },

    openDocumentViewer() {
      if (!this.subscription_status) return;
      else {
        this.getDocumentData.title = this.file.title;
        this.getDocumentData.url = this.file.filename;
        this.getDocumentData.token = this.file.token;
        this.getDocumentData.extension = this.file.extension;
        this.getDocumentData.date = this.formatFileDate(this.file.created_at);
        this.getDocumentData.time = this.formatFileTime(this.file.created_at);
        this.getDocumentData.fullname = `${this.file.user.firstname} ${this.file.user.lastname}`;
        this.getDocumentData.image = this.file.user.image;

        this.show_viewer = true;
      }
    },

    formatFileTime(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatTime(new_date);
    },

    formatFileDate(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatDate(new_date);
    },

    callPaymentStatus(
      child_id = 0,
      class_id = this.file.referenceObject.class_id
    ) {
      this.getSubscriptionPaymentStatus({ child_id, class_id })
        .then((response) => {
          this.subscription_status = true || response.data.status;
        })
        .catch((err) => console.log(err));
    },

    fileType(ext) {
      let fileExt = ext;
      switch (fileExt) {
        case "pdf":
          fileExt = "PDFFILE.svg";
          break;
        case "ppt":
          fileExt = "PPTFILE.svg";
          break;
        case "pptx":
          fileExt = "PPTFILE.svg";
          break;
        case "doc":
          fileExt = "DOCFILE.svg";
          break;
        case "docx":
          fileExt = "DOCXFILE.svg";
          break;
        case "xls":
          fileExt = "XLSFILE.svg";
          break;
        case "xlsx":
          fileExt = "XLSFILE.svg";
          break;
        case "txt":
          fileExt = "TxtFile.svg";
          break;
        case "epub":
          fileExt = "DOCEPUB.png";
          break;
        case "mp4":
          fileExt = "VIDMP4.png";
          break;
        default:
          fileExt = "PDFFILE.svg";
          break;
      }
      return fileExt;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-body {
  padding: 12px 10px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 19px;
  color: $color_ash;
  @include breakpoint_max(lg) {
    font-size: 12px;
    line-height: 17px;
    padding: 8px;
  }
  @include breakpoint_max(lg) {
    font-size: 11px;
    line-height: 13px;
  }
  .section-one {
    width: 60%;
    @include breakpoint_max(md) {
      width: 70%;
    }
    @include breakpoint_custom_max(430) {
      width: 80%;
    }
    .avatar {
      @include equal_min_edge(40);
      margin-right: 10px;
      @include breakpoint_max(lg) {
        @include equal_min_edge(36);
      }
      @include breakpoint_max(sm) {
        @include equal_min_edge(36);
      }
    }
    .title-text {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 2px;
      @include breakpoint_max(lg) {
        font-size: 12.5px;
        line-height: 17px;
      }
      @include breakpoint_max(md) {
        font-size: 12px;
        line-height: 16px;
      }
    }
    .subject-text {
      font-size: 12px;
      line-height: 16px;
      @include breakpoint_max(lg) {
        font-size: 11.5px;
        line-height: 15px;
      }
      @include breakpoint_max(md) {
        font-size: 11px;
        line-height: 13px;
      }
    }
  }
  .section-two {
    width: 30%;
    @include breakpoint_max(xs) {
      display: none;
    }
  }
  .section-three {
    width: 12%;
    @include breakpoint_max(md) {
      width: 18%;
    }
    @include breakpoint_max(xs) {
      width: 24%;
    }
  }

  .locked {
    cursor: not-allowed !important;
  }
}
</style>
